import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"

import {
  toggleConfirmGigApplyDialog,
  toggleGigDialog,
} from "../../actions/gigs"

import Typography from "@material-ui/core/Typography"
import { hiddenLoginModal } from "../../actions/authentication"

class ConfirmGigApplyDialog extends Component {
  constructor(props) {
    super(props)
  }

  handleClose = () => {
    const { gig } = this.props
    this.props.dispatch(toggleConfirmGigApplyDialog(false))
    this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
  }
  applyGig = async () => {
    const { authentication, history } = this.props

    if (authentication.authenticatedUser.id) {
      await this.props.onApplyGig()
    } else {
      this.props.dispatch(toggleConfirmGigApplyDialog(false))
      this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
      hiddenLoginModal()
    }
  }

  render() {
    const {
      fullScreen,
      working,
      confirmGigApplyDialogOpen,
      gig,
      authentication,
    } = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={confirmGigApplyDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        disableBackdropClick
      >
        <form
          id="edit-form"
          noValidate
          autoComplete="off"
          style={{ padding: "20px" }}
        >
          {authentication.authenticatedUser.id ? (
            <DialogTitle disableTypography style={{ textAlign: "center" }}>
              {gig && (
                <Typography variant="h6">
                  {`You Are Applying For The Position Of ${gig.name}`}
                </Typography>
              )}
              <Typography variant="h6">
                {"Do you want to continue ?"}
              </Typography>
            </DialogTitle>
          ) : (
            <DialogTitle disableTypography style={{ textAlign: "center" }}>
              {gig && (
                <Typography variant="h6">
                  {`You need to Login/Register to Apply for the Gig`}
                </Typography>
              )}
              <Typography variant="h6">{"Do you want to login ?"}</Typography>
            </DialogTitle>
          )}
          <DialogContent />
          <DialogActions>
            <Button variant="contained" onClick={this.handleClose}>
              {authentication.authenticatedUser.id ? "Cancel" : "No"}
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              buttonclicked={this.applyGig}
              type="button"
              working={working}
            >
              {authentication.authenticatedUser.id ? "Apply" : "Yes"}
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    confirmGigApplyDialogOpen: state.gigs.confirmGigApplyDialogOpen,
    gig: state.gigs.gigDetails,
    authentication: state.authentication,
  }
}
const connector = connect(mapStateToProps)

export default connector(ConfirmGigApplyDialog)
